import DTO from './DTO';
import { required } from '../utils/validation';

class ReportDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      {
        name: 'report_template_id',
        type: String,
        validators: {},
        labelKey: 'report.template',
      },
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'report.template_name',
      },
      {
        name: 'from_date',
        type: String,
        validators: [required],
        labelKey: 'report.date_start',
      },
      {
        name: 'to_date',
        type: String,
        validators: [required],
        labelKey: 'report.date_end',
      },
      {
        name: 'attributes',
        type: String,
        validators: {},
        labelKey: 'report.attributes',
      },
      {
        name: 'created_at',
        type: String,
        validators: {},
        labelKey: 'created_at',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default ReportDTO;
